import clsx from "clsx"
import { Command } from "cmdk"
import { useContext } from "react"

import useIsDesktop from "@hooks/useIsDesktop"

import { faIcon } from "@utils/faIcon"

import { EmptyState, Popover } from "@molecules"
import { PopoverContext } from "@molecules/Popover/Popover"

import styles from "./SelectList.module.scss"
import { SelectListProps } from "./SelectList.types"

const DEFAULT_EMPTY_STATE = {
    title: "No results found...",
    icon: faIcon({ name: "ban", style: "solid" }),
    variant: "default",
} as const

export default function SelectList(props: SelectListProps) {
    const { title, children, className, emptyState = DEFAULT_EMPTY_STATE, ...rest } = props
    const isDesktop = useIsDesktop()
    const { mobilePresentation } = useContext(PopoverContext)

    const showMobileHeader = !isDesktop && mobilePresentation === "drawer" && title !== undefined

    return (
        <div className={clsx(styles.base, className)} {...rest}>
            {showMobileHeader && (
                <Popover.Header.Root>
                    <Popover.Header.Title title={title} />
                </Popover.Header.Root>
            )}
            <Popover.Body>
                <Command.List>
                    {children}
                    {emptyState !== null && (
                        <Command.Empty>
                            <EmptyState {...emptyState} />
                        </Command.Empty>
                    )}
                </Command.List>
            </Popover.Body>
        </div>
    )
}
